import { render, staticRenderFns } from "./myHead.vue?vue&type=template&id=13d1a841&scoped=true&"
import script from "./myHead.vue?vue&type=script&lang=js&"
export * from "./myHead.vue?vue&type=script&lang=js&"
import style0 from "./myHead.vue?vue&type=style&index=0&id=13d1a841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1a841",
  null
  
)

export default component.exports